/* eslint-disable @typescript-eslint/dot-notation */
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'vm-advice-shell',
  templateUrl: './advice-shell.component.html',
  styleUrls: ['./advice-shell.component.scss'],
})
export class AdviceShellComponent {
  @Input() items = [];
  @Input() backRoute: string;
  @Input() doneRoute: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  onDone() {
    this.router.navigate([this.doneRoute], { relativeTo: this.route });
  }

  onBack() {
    history.back();
  }
}
